import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function HomeLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen font-body text-gray-800">
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-1 bg-white">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
